import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDashboardData } from '../slice/contactUsSlice';
import { FaUsers, FaListAlt, FaCalendarAlt, FaDownload, FaImage } from 'react-icons/fa';
import { MdContacts } from 'react-icons/md';

function Home() {
  const dispatch = useDispatch();
  const Data = useSelector((state) => state.contactus);

  const { table_counts } = Data.data;

  useEffect(() => {
    dispatch(getDashboardData());
  }, [dispatch]);

  return (
    <div className="premium-dashboard-bg">
      <div className="container-fluid">
        
        {/* Animated Premium Header */}
        <div className="dashboard-header-card mb-5">
          <div style={{ position: 'relative', zIndex: 2 }}>
            <h1 className="display-5 font-weight-bold mb-2">Jawahar R-ABI Dashboard</h1>
            <p className="lead mb-0" style={{ opacity: 0.9 }}>Welcome to the incubation management portal</p>
          </div>
        </div>

        <div className="row">
          
          {/* Startups */}
          <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div className="premium-stat-card d-delay-1" style={{ '--card-color': '#1e88e5', '--icon-bg': 'rgba(30, 136, 229, 0.1)' }}>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="premium-stat-label">Startups</div>
                  <div className="premium-stat-count">{table_counts?.startups || 0}</div>
                </div>
                <div className="icon-circle">
                  <FaUsers />
                </div>
              </div>
              <div className="premium-stat-footer mt-3">Incubated Startups</div>
            </div>
          </div>

          {/* Programs */}
          <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div className="premium-stat-card d-delay-2" style={{ '--card-color': '#43a047', '--icon-bg': 'rgba(67, 160, 71, 0.1)' }}>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="premium-stat-label">Programs</div>
                  <div className="premium-stat-count">{table_counts?.programs || 0}</div>
                </div>
                <div className="icon-circle">
                  <FaListAlt />
                </div>
              </div>
              <div className="premium-stat-footer mt-3">Incubation Schemes</div>
            </div>
          </div>

          {/* Events */}
          <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div className="premium-stat-card d-delay-3" style={{ '--card-color': '#fb8c00', '--icon-bg': 'rgba(251, 140, 0, 0.1)' }}>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="premium-stat-label">Events</div>
                  <div className="premium-stat-count">{table_counts?.events || 0}</div>
                </div>
                <div className="icon-circle">
                  <FaCalendarAlt />
                </div>
              </div>
              <div className="premium-stat-footer mt-3">Event PDF Files</div>
            </div>
          </div>

          {/* Downloads */}
          <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div className="premium-stat-card d-delay-4" style={{ '--card-color': '#00897b', '--icon-bg': 'rgba(0, 137, 123, 0.1)' }}>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="premium-stat-label">Downloads</div>
                  <div className="premium-stat-count">{table_counts?.downloads || 0}</div>
                </div>
                <div className="icon-circle">
                  <FaDownload />
                </div>
              </div>
              <div className="premium-stat-footer mt-3">Download PDF Files</div>
            </div>
          </div>

          {/* Gallery */}
          <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div className="premium-stat-card d-delay-5" style={{ '--card-color': '#5e35b1', '--icon-bg': 'rgba(94, 53, 177, 0.1)' }}>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="premium-stat-label">Gallery</div>
                  <div className="premium-stat-count">{table_counts?.gallery || 0}</div>
                </div>
                <div className="icon-circle">
                  <FaImage />
                </div>
              </div>
              <div className="premium-stat-footer mt-3">Gallery Media</div>
            </div>
          </div>

          {/* Team Members */}
          <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div className="premium-stat-card d-delay-6" style={{ '--card-color': '#e53935', '--icon-bg': 'rgba(229, 57, 53, 0.1)' }}>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="premium-stat-label">Team</div>
                  <div className="premium-stat-count">{table_counts?.team || 0}</div>
                </div>
                <div className="icon-circle">
                  <FaUsers />
                </div>
              </div>
              <div className="premium-stat-footer mt-3">Incubator Team Members</div>
            </div>
          </div>

          {/* Enquiries */}
          <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
            <div className="premium-stat-card d-delay-7" style={{ '--card-color': '#3949ab', '--icon-bg': 'rgba(57, 73, 171, 0.1)' }}>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="premium-stat-label">Enquiries</div>
                  <div className="premium-stat-count">{table_counts?.enquiries || 0}</div>
                </div>
                <div className="icon-circle">
                  <MdContacts />
                </div>
              </div>
              <div className="premium-stat-footer mt-3">Visitor Queries</div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Home;
